import { render } from "./QAndACommentItem.vue?vue&type=template&id=03e249c0"
import script from "./QAndACommentItem.vue?vue&type=script&lang=js"
export * from "./QAndACommentItem.vue?vue&type=script&lang=js"

import "./QAndACommentItem.vue?vue&type=style&index=0&id=03e249c0&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__